// extracted by mini-css-extract-plugin
export default {"fieldSet":"AddCertificatesModal_fieldSet__91j84","flex":"AddCertificatesModal_flex__iQe-3"};